const getHubName = (hub, labels, getNameFromTarget = false) => {
  const label =
    labels?.[`HUB_${(getNameFromTarget ? hub?.linkTarget?.parent : hub)?.segment?.toUpperCase()}`];
  return label || hub?.title;
};

export default getHubName;
